import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ApproveOrderIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ApproveOrderIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M17.5 21C19.9853 21 22 18.9853 22 16.5C22 14.0147 19.9853 12 17.5 12C15.0147 12 13 14.0147 13 16.5C13 18.9853 15.0147 21 17.5 21Z"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17.2L17.1429 18L19 16"
        stroke="#503291"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5232 18.4923L5.2002 18.5031C4.53735 18.5031 4 17.9658 4 17.3029V5.14759C4 4.48473 4.53735 3.94739 5.2002 3.94739H17.5252C18.1881 3.94739 18.7254 4.48473 18.7254 5.14759C18.7254 5.14759 18.7254 10.2882 18.7254 10.4675"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path d="M4.00049 8.52722H8.49316H9.32481" stroke="#503291" />
      <path d="M13.0342 8.52722H17.6235H18.5422" stroke="#503291" />
      <path
        d="M9.44193 3.94763L9.44193 10.5799C9.44193 10.5799 9.41104 10.9892 9.69104 10.814C9.97103 10.6388 11.5316 9.75889 11.5316 9.75889C11.5316 9.75889 12.9323 10.7079 13.2653 10.9569C13.5984 11.206 13.5532 10.3313 13.5532 10.3313V3.94763H9.44193Z"
        stroke="#503291"
      />
    </Icon>
  )
}
export default ApproveOrderIcon
